<template>
    <div class="page order-detail-child order-detail-zdh">
        <div class="order-wrap">
            <div class=" page-path">
                <span @click="toPath(1)">快马签证</span> >
                <span @click="toPath(2)">订单中心</span> >
                <span @click="toPath(3)">资料上传</span>
            </div>

            <div class="page-order-detaul-bom">
                <div class="page-order-detail-left">
                    <div class="page-order-item-info" style="overflow: hidden"
                        :style="{ height: isUp ? 'auto' : '210px' }">
                        <div class="page-order-item-t">
                            <span>订单号：</span>
                            <p id="copy">{{ orderDetail.order.orderNo }}</p>
                            <el-button type="text" style="font-size: 16px; padding: 0; padding-left: 5px"
                                class="el-icon-document-copy" v-clipboard:copy="orderDetail.order.orderNo"
                                v-clipboard:success="copySuccess" v-clipboard:error="copyError">
                            </el-button>

                            <!-- setStatus -->
                            <div class="page-order-status-name" :class="[setStatus(orderDetail.order.status)]">
                                {{ orderDetail.order.statusName }}
                            </div>
                            <el-button type="text" class="el-icon-s-grid" v-if="orderDetail.order.orderSource == 1"
                                style="position: absolute; right: 0px;top:-10px" @click="isQrcodeImg = true">
                            </el-button>
                        </div>
                        <div class="page-order-item-t">
                            <span>金额/实收：</span>
                            <p style="margin-right:10px">{{ orderDetail.order.payableAmount ==
                                (orderDetail.order.paidAmount -
                                    orderDetail.order.refundAmount)
                                ? orderDetail.order.payableAmount :
                                `${orderDetail.order.payableAmount}/${orderDetail.order.paidAmount -
                                orderDetail.order.refundAmount}` }}
                            </p>
                            <el-link type="primary" @click.stop="openReceive(orderDetail.order)"
                                v-if="orderDetail.order.orderSource == 1" icon="el-icon-edit-outline"></el-link>
                        </div>
                        <div class="page-order-item-t">
                            <span>国家-类型：</span>
                            <p>
                                {{
                                    orderDetail.visaDetail &&
                                    orderDetail.visaDetail.visa &&
                                    orderDetail.visaDetail.visa.countryName
                                }}-{{
                                    orderDetail.visaDetail &&
                                    orderDetail.visaDetail.visa &&
                                    orderDetail.visaDetail.visa.typeName
                                }}
                            </p>
                        </div>
                        <div class="page-order-item-t">
                            <span>产品名称：</span>
                            <p id="copy">
                                {{ orderDetail.order.visaTitle }}
                                <!-- <i i style="color: #3888E9;" @click="copyOrder"
                                    class="el-icon-document-copy"></i> -->
                            </p>
                        </div>
                        <div class="page-order-item-t">
                            <span>下单时间：</span>
                            <p>
                                {{
                                    orderDetail.order.createdTime &&
                                    orderDetail.order.createdTime.split(" ")[0]
                                }}
                            </p>
                        </div>
                        <div class="page-order-item-t">
                            <span>预计出行：</span>
                            <p>
                                {{
                                    orderDetail.order.departureTime &&
                                    orderDetail.order.departureTime.split(" ")[0]
                                }}
                            </p>
                            <!-- 新增修改详情页预计出行时间 -->
                            <el-link style="margin-left: 5px;" type="primary"
                                @click.stop="openChangeTime(orderDetail.order, '出行日期')"
                                icon="el-icon-edit-outline"></el-link>
                        </div>

                        <div class="page-order-item-t" v-if="orderDetail.order.marks">
                            <p class="marks-line" style="color: #e41313;">
                                客户备注：
                                {{
                                    orderDetail.order.marks
                                }}
                            </p>
                        </div>
                        <div class="page-order-item-t">
                            <span> 操作备注： </span>

                            <span class="marks-line">
                                <el-popover placement="top" width="160" v-model="showMarksDialog">
                                    <p>操作备注</p>
                                    <el-input v-model="textarea" type="textarea" :rows="4" resize="none" />
                                    <div style="text-align: right; margin: 0; margin-top: 10px;">
                                        <el-button class="default" size="small" @click="submitTextareaFn">保存</el-button>
                                    </div>
                                    <i slot="reference" class="iconfont icon-a-xiugai1"></i>
                                </el-popover>
                                {{
                                    orderDetail.order.serviceMarks ? orderDetail.order.serviceMarks : "--"
                                }}
                            </span>

                        </div>
                        <div class="page-order-item-t">
                            <span>联系方式：</span>
                            <p>
                                <span class="source-type" :style="{
                                    background: setOrderSourceColor(orderDetail.order.orderSource),
                                }">{{ setOrderSourceText(orderDetail.order.orderSource) }}</span>
                                <span> {{ orderDetail.order.contacts || "--" }}</span>
                                <span> {{ orderDetail.order.contactPhone || "--" }}</span>
                            </p>
                        </div>
                        <div class="page-order-item-t" v-if="orderDetail.order.embassyDate">
                            <span>预约信息：</span>
                            <p>{{ orderDetail.order.embassyDate.str }}</p>
                        </div>
                        <div class="page-order-up" @click="isUp = !isUp">
                            <span v-if="!isUp">展开<i class="el-icon-arrow-down"></i></span>
                            <span v-else>收起<i class="el-icon-arrow-up"></i></span>
                        </div>
                    </div>

                    <div class="page-order-item-table">
                        <div class="page-order-detail-btn">
                            <el-button size="small" class="default" style="margin-right: 10px"
                                v-if="orderDetail.order.orderSource != 0" @click="addUser">添加申请人</el-button>
                            <el-dropdown @command="handleCommand">
                                <el-button size="small" class="default">批量处理<i
                                        class="el-icon-arrow-down el-icon--right"></i></el-button>
                                <el-dropdown-menu slot="dropdown">
                                    <el-dropdown-item command="a">批量下载</el-dropdown-item>
                                    <el-dropdown-item command="b"
                                        v-if="orderDetail.order.autocommit">批量提交</el-dropdown-item>
                                    <el-dropdown-item command="c">批量刷新</el-dropdown-item>
                                    <el-dropdown-item command="e">发送邮件</el-dropdown-item>
                                    <el-dropdown-item command="f">导出名单</el-dropdown-item>
                                    <el-dropdown-item command="g">头像提取</el-dropdown-item>
                                    <el-dropdown-item command="h">批量核验</el-dropdown-item>
                                    <el-dropdown-item command="d" v-if="vfsList.includes(vfs)">批量取消</el-dropdown-item>
                                </el-dropdown-menu>
                            </el-dropdown>
                            <el-input placeholder="请输入" v-model="applicationName" clearable
                                style="width: 140px;margin-left: 10px" size="small">
                                <el-button slot="append" size="mini" icon="el-icon-search"
                                    @click="pageIndex = 1; queryorderapplicantsFn()"></el-button>
                            </el-input>
                        </div>

                        <!-- :height="$store.state.product.screen ? '820px' : '470px'" -->
                        <div class="page-order-table-box" v-loading="applicationLoading">
                            <!-- @row-click="setColl" :height="$store.state.product.screen ? '550px' : '420px'" -->
                            <el-table :data="userList" v-if="userList.length" ref="tableOrder" :header-cell-style="{
                                backgroundColor: 'none',
                                color: '#333',
                                fontWeight: 'bold',
                                textAlign: 'center',
                                fontSize: '10px',
                            }" height="calc( 100% - 110px)" @row-click="setColl"
                                :cell-style="{ 'text-align': 'center' }" :row-class-name="rowClassFun"
                                highlight-current-row>
                                <!--  -->

                                <el-table-column prop="applicantName" label="姓名" width="70px">
                                    <template slot-scope="scope">
                                        <span>{{ scope.row.applicantName }}</span>
                                        <div class="flex-app">
                                            <el-progress v-if="scope.row.taskTable" :show-text="false"
                                                define-back-color="#EAF3FF" :percentage="scope.row.taskTable"
                                                :width="25" :height="35" :stroke-width="6"
                                                :color="colors"></el-progress>
                                        </div>
                                    </template>
                                </el-table-column>
                                <el-table-column prop="identityTypeName" label="身份类型" width="100px">
                                    <template slot-scope="scope">
                                        <div class="select-input">
                                            <el-select v-model="scope.row.identityType" placeholder="请选择"
                                                @change="selectIdentit($event, scope.row)">
                                                <el-option v-for="item in orderDetail.visaDetail.visaDocs"
                                                    :key="item.identityTypeId" :label="item.name"
                                                    :value="item.identityTypeId">
                                                </el-option>
                                            </el-select>
                                        </div>
                                    </template>
                                </el-table-column>
                                <el-table-column prop="statusName" label="申请状态" width="100px">
                                    <template slot="header" slot-scope="scope">
                                        <el-dropdown trigger="click" @command="handleFilterChange">
                                            <div class="filter_btn" :class="Status >= 0 ? 'active' : ''">申请状态<i
                                                    class="el-icon-arrow-down"></i>
                                            </div>
                                            <el-dropdown-menu slot="dropdown">
                                                <el-dropdown-item :command="-99"
                                                    :class="Status == -99 ? 'active' : ''">全部</el-dropdown-item>
                                                <el-dropdown-item :key="item.value" v-for="item in statusSelect"
                                                    :command="item.value"
                                                    :class="Status == item.value ? 'active' : ''">{{ item.label
                                                    }}</el-dropdown-item>
                                            </el-dropdown-menu>
                                        </el-dropdown>
                                    </template>
                                    <!-- <template slot-scope="scope">
                                        <div class="select-input">
                                            <el-select v-model="scope.row.status" placeholder="请选择"
                                                @change="selectStatus($event, scope.row)" :class="setTopClass(scope.row.status)">
                                                <el-option v-for="item in statusSelect" :key="item.value"
                                                    :label="item.label" :value="item.value">
                                                </el-option>
                                            </el-select>
                                        </div>
                                    </template> -->
                                    <template slot-scope="scope">
                                        <div class="flex-app">
                                            <div :style="setTopClass(scope.row.status)">
                                                {{ scope.row.statusName }}
                                            </div>
                                        </div>
                                    </template>
                                </el-table-column>

                                <el-table-column label="操作" header-align="center" width="80px">
                                    <template slot-scope="scope">
                                        <span class="lan" v-if="[0, 4].indexOf(scope.row.status) != -1"
                                            @click="selectStatus(2, scope.row)">审核</span>
                                        <span class="lan" v-if="[2].indexOf(scope.row.status) != -1"
                                            @click="selectStatus(4, scope.row)">资料不完善</span>
                                        <span class="lan" v-if="[16].indexOf(scope.row.status) != -1"
                                            @click="setHandleCommand('b', scope.row)">下载</span>
                                        <!-- 被拒签时下载拒签文件 -->
                                        <span class="lan" v-if="scope.row.status == 17 && scope.row.rejectLetter"
                                            @click="setHandleCommand('c', scope.row)">下载</span>
                                        <span class="lan" v-if="[12].indexOf(scope.row.status) != -1"
                                            @click.stop="openPay(scope.row)">{{
                                                isUrl(scope.row.payUrl) ? '支付' : '复制' }}</span>
                                        <span class="lan"
                                            v-if="([20].indexOf(scope.row.status) != -1 || scope.row.status == submitIngStatus) && vfsList.includes(vfs)"
                                            @click="cancelStatus(scope.row)">取消</span>

                                        <el-upload v-if="scope.row.status == 14" action=""
                                            :http-request="uploadVisapage">
                                            <span class="lan"> 上传 </span>
                                        </el-upload>

                                        <i class="el-icon-loading" v-if="scope.row.status == submitIngStatus"></i>
                                        <span class="lan" v-if="scope.row.status == submitIngStatusCancelPay">取消中</span>
                                    </template>
                                </el-table-column>
                            </el-table>
                            <div v-else style="text-align: center; margin-top: 100px">
                                <img src="@/assets/images/orderCenter/empty1.png" alt="暂无数据"
                                    style="width: 137px; height: 115px; margin-top: 50px" />
                                <p style="color: #cccccc; margin-top: 16px; font-size: 12px">
                                    客户列表为空
                                </p>
                                <span v-if="Status != -99">
                                    <el-button size="mini" type="primary"
                                        @click="handleFilterChange(-99)">重置筛选</el-button>
                                </span>
                            </div>
                            <div class="table-pagination" v-show="userList.length">
                                <el-pagination @current-change="addressCurrentChange" :current-page="pageIndex"
                                    :pager-count="5" small :page-size="pageSize"
                                    layout="total, prev, pager, next, jumper" :total="total">
                                </el-pagination>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="page-order-detail-bottom" v-loading="applicantLoading">

                    <div style="position: absolute; top: -45px; background: transparent;"
                        v-if="(orderDetail.visaDetail && !orderDetail.visaDetail.visa.isTable) || orderDetail.order.orderSource == 1">
                        <el-tabs v-model="activeName">
                            <el-tab-pane label="申请表" name="second"></el-tab-pane>
                            <el-tab-pane label="资料列表" name="first"> </el-tab-pane>
                        </el-tabs>
                    </div>
                    <div class="page-order-detail" v-show="activeName == 'first'"
                        v-if="((orderDetail.visaDetail && !orderDetail.visaDetail.visa.isTable) || orderDetail.order.orderSource == 1) && applicationForm.id">
                        <informationsApplication :detailId="applicationForm.id"></informationsApplication>
                    </div>

                    <div class="page-order-detail"
                        :class="{ 'page-table-box': ((orderDetail.visaDetail && !orderDetail.visaDetail.visa.isTable) || orderDetail.order.orderSource == 1) && activeName == 'first' }">

                        <div class="page-order-detail-bottom-content" :style="{ height: 'calc( 100% - 70px)' }">
                            <template>
                                <iframe v-if="isShow" :src="iframeUrl" class="page-card-iframe" ref="iframeRef"
                                    frameborder="0" scrolling="auto" style="height: 100%;"></iframe>
                            </template>
                            <div v-if="!applicationForm.applicationForm" class="no-iframe">
                                <img src="@/assets/images/orderCenter/empty2.png" alt="暂无数据"
                                    style="width: 162px; height: 147px" />
                            </div>
                        </div>
                        <div class="page-rder-detail-bottom-btn">
                            <div style="display: flex; align-items: center;">

                                <!-- class="default" -->
                                <!-- 被拒签也不能进行操作 -->
                                <span v-if="applicationForm.status == 12 && !isUrl(applicationForm.payUrl)"
                                    style="margin-right:5px;margin-left:8px;">
                                    <div style="display:flex;height:25px;line-height: 25px;gap:8px;padding-bottom: 5px;"
                                        v-if="applicationForm.payUrl">
                                        付款编号：{{
                                            applicationForm.payUrl }}<el-button type="primary" size="mini"
                                            @click="copyText(applicationForm.payUrl)">复制</el-button></div>
                                    <div style="display:flex;height:25px;line-height: 25px;gap:8px;"
                                        v-if="applicationForm.applyNumber">
                                        申请编号：{{
                                            applicationForm.applyNumber
                                        }}<el-button type="primary" size="mini"
                                            @click="copyText(applicationForm.applyNumber)">复制</el-button></div>
                                </span>
                                <template v-else>
                                    <el-button type="primary" v-if="applicationForm.status == submitIngStatusCancelPay"
                                        disabled>取消中</el-button>
                                    <el-button type="primary"
                                        v-else-if="orderDetail.order.autocommit && applicationForm.status != 18"
                                        :disabled="submitLoading || applicationForm.status == 10 || applicationForm.taskTable != 100 || applicationForm.status == 17"
                                        :loading="submitLoading || applicationForm.status == 10" @click="clickSubmit"
                                        :style="applicationForm.status == 14 ? 'padding: 0' : ''">
                                        <span v-if="applicationForm.status == 10">提交中</span>
                                        <span v-else-if="applicationForm.status == 20">重新提交</span>
                                        <span v-else-if="applicationForm.status == 12">{{ isUrl(applicationForm.payUrl)
                                            ? '前往支付' : ''
                                            }}</span>
                                        <span v-else-if="applicationForm.status == 16">下载签证页</span>
                                        <el-upload ref="uploadRef" @click.stop=""
                                            v-else-if="applicationForm.status == 14" action=""
                                            :http-request="uploadVisapage">
                                            <el-button type="primary"> <i class="iconfont icon-shangchuan visa-icon"
                                                    style="color: #ffffff">上传签证页</i>
                                            </el-button>
                                        </el-upload>
                                        <span v-else-if="applicationForm.status == submitIngStatusCancelPay">取消中</span>
                                        <span v-else>提交到大使馆网站</span>
                                    </el-button>
                                </template>

                                <span
                                    v-if="applicationForm.status == 14 && orderDetail.visaDetail.visa.countryName == '巴基斯坦'">
                                    <div
                                        style="display:flex;height:25px;line-height: 25px;gap:8px;padding-bottom: 5px;margin-left: 10px;">
                                        申请编号：{{
                                            applicationForm.applyNumber }}<el-button type="primary" size="mini"
                                            @click="copyText(applicationForm.applyNumber)">复制</el-button></div>
                                </span>

                                <el-button v-if="applicationForm.status == 12 && canCancelPay" type="text"
                                    style="margin-left: 20px;" @click="cancelpay">取消支付</el-button>
                                <i class="el-icon-loading"
                                    v-else-if="applicationForm.status == submitIngStatusCancelPay"
                                    style="margin-left: 20px;"></i>
                                <el-button
                                    v-if="(applicationForm.status != 0 && applicationForm.status != 2 && applicationForm.status != 4) && seachEmailHistory"
                                    type="text" @click="reportsuccess" style="margin-left: 20px;cursor: pointer;"><i
                                        class="el-icon-eleme"></i>邮件查询</el-button>


                                <el-tooltip v-if="applicationForm.status == 20" :content="applicationForm.latestStatus">
                                    <div
                                        style="color: red;width: 300px; word-break: keep-all; text-overflow: ellipsis; overflow: hidden;line-height: 15px;">
                                        {{ applicationForm.latestStatus }}
                                    </div>
                                </el-tooltip>


                                <div style="display: flex;flex-direction: column;align-items: start;line-height: 20px;gap: 4px;margin-left: 10px;"
                                    v-if="applicationForm.status == 18">
                                    <div style="display: flex;">
                                        申请编号：{{ applicationForm.applyNumber }}
                                        <div style="color: #0094e8;cursor: pointer;margin-left: 10px;"
                                            @click="handleCopy(applicationForm.applyNumber)">复制</div>
                                    </div>
                                    <el-tooltip :content="applicationForm.latestStatus">
                                        <div style="display: flex;">反馈描述：
                                            <div
                                                style="color: red;width: 360px; word-break: keep-all; text-overflow: ellipsis; overflow: hidden;line-height: 20px;white-space: nowrap;text-align: left;">
                                                {{ applicationForm.latestStatus }}
                                            </div>
                                        </div>
                                    </el-tooltip>
                                </div>
                            </div>
                            <div>
                                <span style="
                    font-size: 16px;
                    color: #0094e8;
                    margin-right: 32px;
                    cursor: pointer;
                  " @click="reload">刷新</span>
                                <!--  class="default" -->

                                <el-button type="primary" plain v-if="applicationForm.canUpdateInfo"
                                    @click="iframeUpdate">修改</el-button>
                                <el-button type="primary" :disabled="[8, 10, 14, 16, 12].indexOf(applicationForm.status) != -1
                                    " @click="iframeSubmit">保存</el-button>
                                <!--  class="text2" -->
                                <el-button type="danger" :disabled="[8, 10, 14, 16, 12].indexOf(applicationForm.status) != -1
                                    " style="margin-right: 6px" @click="delUser">删除</el-button>
                            </div>
                        </div>

                    </div>
                </div>
            </div>
        </div>

        <el-dialog title="修改申请人身份" :close-on-click-modal="false" center :visible.sync="isVisible" width="360px"
            :before-close="handleClose" class="dialog-wrap">
            <div class="sf-list">
                <p class="sf-label">不同身份类型，签证资料可能会有区别</p>
                <el-radio v-model="sfObj.identityType" size="medium" class="sf-radio" :label="item.identityTypeId"
                    v-for="(item, index) in orderDetail.visaDetail.visaDocs" :key="index">{{ item.name }}</el-radio>
                <div class="sf-btn">
                    <el-button @click="isVisible = false">取消</el-button>
                    <el-button class="default" @click="editSf">确认</el-button>
                </div>
            </div>
        </el-dialog>
        <el-dialog title="备注信息" :close-on-click-modal="false" :fullscreen="true" center :visible.sync="beizhuShow"
            width="419px" :before-close="handleClose" class="dialog-order-detail-wrap">
            <div class="dialog-member-title">
                <span class="dialog-member-name">备注信息</span>
                <div class="dialog-close" @click="beizhuShow = false">
                    <i class="el-icon-close"></i>
                </div>
            </div>
            <div class="sf-list-zb" style="margin-top: 15px">
                <el-input type="textarea" :rows="5" placeholder="请输入内容" v-model="textarea">
                </el-input>

                <div class="packge-btn-add" style="margin-top: 15px">
                    <el-button class="pageck-btn" @click="beizhuShow = false">取消</el-button>
                    <el-button class="pageck-btn default" type="primary" @click="submitBz('ruleForm')">确认</el-button>
                </div>
            </div>
        </el-dialog>
        <!-- 变更状态 -->
        <el-dialog :visible.sync="changeStatusShow" width="419px" class="detail-status-dialog"
            :close-on-click-modal="true">
            <div class="dialog-member-title">
                <span class="dialog-member-name">变更{{ changeStatusType }}</span>
                <div class="dialog-close" @click="changeStatusShow = false">
                    <i class="el-icon-close"></i>
                </div>
            </div>
            <div class="quan-num-add">
                <div class="quan-num-add-item" style="margin: 30px 0">
                    <el-date-picker v-model="changeStatusTime" type="date" :placeholder="`选择${changeStatusType}`"
                        value-format="yyyy-MM-dd">
                    </el-date-picker>
                </div>
                <div class="packge-btn-add">
                    <el-button class="pageck-btn" @click="changeStatusShow = false">取消</el-button>
                    <el-button class="pageck-btn default" type="primary" @click="changeStatusSubmit">确认</el-button>
                </div>
            </div>
        </el-dialog>
        <el-dialog id="check-email-pop" title="邮件通知记录" :close-on-click-modal="false" top="8vh"
            :visible.sync="showEmailPop" width="800px">
            <div class="email-record-container" v-loading="emailLoading">
                <!-- 弹窗内容区域 -->
                <div class="email-record-container">
                    <!-- 顶部信息栏 -->
                    <div class="header-info">
                        <span class="info-item">护照号：{{ applicationForm.passportNumber }}</span>
                        <span class="info-item">姓名：{{ applicationForm.applicantName }}</span>
                        <span class="info-item" v-if="applicationForm.applyNumber">申请号: {{ applicationForm.applyNumber
                            }}</span>
                    </div>

                    <!-- 邮件数量 + 刷新按钮 行 -->
                    <div class="count-refresh-row">
                        <div class="email-count">共 {{ emailList.length }} 封邮件</div>
                        <el-button type="primary" icon="el-icon-refresh" class="refresh-btn" size="mini"
                            @click="seachnewemaildata">
                            刷新
                        </el-button>
                    </div>

                    <!-- 可滚动的邮件列表容器 -->
                    <div class="email-list-scroll">
                        <!-- 邮件列表 -->
                        <div class="email-list">
                            <!-- 动态渲染邮件列表 -->
                            <div class="email-item" v-for="(item, index) in emailList" :key="item.id || index">
                                <i style="font-size: 19px;" class="el-icon-success" :class="item.statusClass"></i>
                                <div class="email-content" style="margin-left: 15px;">
                                    <div>
                                        <span class="status-label">{{ item.title }}</span>
                                        <span class="email-time">{{ item.createdTime }}</span>
                                    </div>
                                    <!-- 截断/展开的邮件内容 -->
                                    <div class="email-desc" :class="{ 'expanded': expandStatus[index] }"
                                        v-html="item.content">
                                    </div>
                                    <!-- 查看详情/收起 按钮 -->
                                    <a href="javascript:;" class="view-detail" @click="toggleEmailExpand(index)">
                                        {{ expandStatus[index] ? '收起' : '查看详情' }}
                                    </a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button @click="showEmailPop = false">关闭</el-button>
            </span>
        </el-dialog>
        <batchApplication ref="batchApplicationRef" :visible="tjShow" :orderId="id" :orderDetail="orderDetail"
            :visaId="orderDetail.visaDetail && orderDetail.visaDetail.visa.visaId" :dowmShow="dowmShow"
            :downTitle="downList.title" @close="tjShow = false; dowmShow = false" @refresh="queryorderapplicantsFn"
            @confirm="confirmSubmit"></batchApplication>
        <batchApplicationSubmit :visible="submitApplicationShow" :orderId="id" :isBatch="isBatch"
            :length="userListAllTable.length" @confirm="confirmSubmit" @close="submitApplicationShow = false">
        </batchApplicationSubmit>
        <addUserInfoTwo :config="newAddUserShow" :orderId="id" :isAddOrder="false"
            :visaDocsInfo="orderDetail.visaDetail.visaDocs" :order="orderDetail.order" v-if="newAddUserShow"
            @addUserFn="addUserFn" @close="newAddUserShow = false">
        </addUserInfoTwo>

        <orderQRCodeDialog :visible="isQrcodeImg" :orderDetail="orderDetail" @close="isQrcodeImg = false"
            :applicationForm="applicationForm" :departureTime="changeStatusTime">
        </orderQRCodeDialog>

        <!-- 订单收款对话框 -->
        <el-dialog :visible.sync="visibleReceive" width="1100px" :close-on-click-modal="true" title="订单收款">
            <div class="order-receive-container">
                <!-- 订单信息 -->
                <div class="order-info">
                    <div class="info-row">
                        <span class="info-item">订单号: <span class="info-value">{{ query.orderNo }}</span></span>
                        <span class="info-item">下单时间: <span class="info-value">{{ query.createdTime }}</span></span>
                        <span class="info-item">备注: <span class="info-value">{{ query.serviceMarks }}</span></span>
                        <span class="info-item">
                            商户信息:
                            <span class="info-value" style="margin-right: 10px;" v-if="query.merchantName">{{
                                query.merchantName
                                }}</span>
                            <!-- <el-button v-if="query.merchantName" type="primary" size="small" @click="openConnectMerchant(query)">更改</el-button>   -->
                            <el-button v-else type="primary" size="small"
                                @click="openConnectMerchant(query)">关联商户</el-button>
                        </span>
                        <span class="info-item">
                            客户信息:
                            <span style="margin-right: 10px;" class="info-value" v-if="query.coreCustomerName">{{
                                query.coreCustomerName
                                }}</span>
                            <el-button v-if="query.coreCustomerName" type="primary" size="small"
                                @click="openConnectCoreCustomer(query)">更改</el-button>
                            <el-button v-else type="primary" size="small"
                                @click="openConnectCoreCustomer(query)">关联客户</el-button>
                        </span>
                    </div>
                    <div class="info-row">
                        <span class="info-item">订单应收金额:
                            <el-input v-if="isEdit" v-model="query.payableAmount" placeholder="请输入应收金额"
                                style="width: 120px;" size="small">
                            </el-input>
                            <span v-if="!isEdit">{{ query.payableAmount }}</span>
                            <a href="#" class="modify-link" @click="cancelEdit">{{ isEdit ? '取消' : '修改' }}</a>
                        </span>
                        <span class="info-item" v-show="isEdit">是否已收:
                            <el-select v-model="query.isPaid" placeholder="是否已收" size="small" style="width: 80px;">
                                <el-option label="是" :value="true"></el-option>
                                <el-option label="否" :value="false"></el-option>
                            </el-select>
                        </span>
                        <span class="info-item" style="margin-left: 0px;" v-show="query.isPaid && isEdit">收款账户:
                            <el-select v-model="query.accountId" placeholder="未选择" size="small" style="width: 150px;">
                                <el-option v-for="item in accountList" :key="item.value" :label="item.label"
                                    :value="item.value"></el-option>
                            </el-select>
                        </span>
                        <el-button type="primary" size="small" style="margin-left: auto" v-show="query.status && isEdit"
                            @click="saveReceive">保存</el-button>
                    </div>
                    <div class="info-row"><span class="info-item">实收款: <span class="info-value">{{ query.paidAmount
                                }}</span></span>
                        <span class="info-item">剩余应收: <span class="info-value">{{ query.orgPayableAmount -
                            query.paidAmount
                                }}</span></span>
                    </div>
                </div>

                <!-- 收款信息 -->
                <div class="receive-info">
                    <div class="receive-row" v-show="query.status">
                    </div>
                    <div class="receive-actions">
                        <el-button type="default" size="small" style="margin-left: 10px;"
                            @click="visibleAddReceive = true">新增收款</el-button>
                    </div>
                </div>

                <!-- 支付记录 -->
                <div class="payment-records">
                    <el-table :data="receiveList"
                        :header-cell-style="{ backgroundColor: '#F2F4F7', color: '#333', fontWeight: 'bold', textAlign: 'center', fontSize: '12px' }"
                        style="width: 100%" v-loading="receiveLoading" :height="'370px'"
                        :cell-style="{ 'text-align': 'center' }">
                        <el-table-column prop="createdTime" label="支付日期" width="150"></el-table-column>
                        <el-table-column prop="amount" label="支付金额"></el-table-column>
                        <el-table-column prop="accountName" label="账户"></el-table-column>
                        <el-table-column prop="status" label="是否收款">
                            <template slot-scope="scope">
                                <el-tag :type="scope.row.status === 1 ? 'success' : 'danger'">{{ scope.row.statusName
                                    }}</el-tag>
                            </template>
                        </el-table-column>
                        <el-table-column prop="userName" label="操作人"></el-table-column>
                        <el-table-column prop="remark" label="备注"></el-table-column>
                        <el-table-column prop="imageUrl" label="支付快照">
                            <template slot-scope="scope">
                                <el-image v-if="scope.row.imageUrl" :src="scope.row.imageUrl"
                                    :preview-src-list="[scope.row.imageUrl]" fit="cover"
                                    style="width: 80px; cursor: pointer;"></el-image>
                                <div v-else>无截图</div>
                            </template>
                        </el-table-column>
                        <el-table-column prop="handler" label="操作">
                            <template slot-scope="scope">
                                <el-button type="danger" size="small" @click="cancelReceive(scope.row)"
                                    v-if="scope.row.status === 1">撤销收款</el-button>
                            </template>
                        </el-table-column>
                    </el-table>
                </div>
            </div>
        </el-dialog>

        <!-- 新增收款对话框 -->
        <el-dialog :visible.sync="visibleAddReceive" width="500px" :close-on-click-modal="true" title="收款">
            <div class="add-receive-container">
                <el-form :model="addReceiveForm" :rules="addReceiveFormRules" ref="addReceiveFormRef"
                    label-width="100px" size="small">
                    <el-form-item label="金额:" prop="amount">
                        <el-input v-model="addReceiveForm.amount" placeholder="金额"
                            @input="handleAmountInput"></el-input>
                    </el-form-item>
                    <el-form-item label="账户:" prop="accountId">
                        <el-select v-model="addReceiveForm.accountId" placeholder="未选择" size="small"
                            style="width:100%;">
                            <el-option v-for="item in accountList" :key="item.value" :label="item.label"
                                :value="item.value"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="备注:">
                        <el-input v-model="addReceiveForm.remark" placeholder="备注" type="textarea" rows="2"></el-input>
                    </el-form-item>
                    <el-form-item label="快照:" prop="imageUrl">
                        <upload v-model="addReceiveForm.imageUrl" accept="img" :auto-upload="true"
                            :image-url="addReceiveForm.imageUrl" :drag="'drag'" thisType="custom"
                            @input="toImg($event, 'imageUrl')" :customSty="{ width: '320px', height: '154px' }">
                        </upload>
                    </el-form-item>
                </el-form>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button @click="visibleAddReceive = false">取消</el-button>
                <el-button type="primary" @click="saveAddReceive">保存</el-button>
            </span>
        </el-dialog>

        <!-- 关联商户对话框 -->
        <el-dialog :visible.sync="connectMerchantDialog" width="500px" title="关联商户" :close-on-click-modal="false">
            <el-form label-width="100px">
                <el-form-item label="选择商户:">
                    <el-select filterable clearable v-model="connectMerchantId" placeholder="请选择商户"
                        style="width: 100%;">
                        <el-option v-for="item in connectMerchantList" :key="item.id" :label="item.companyName"
                            :value="item.id">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="历史记录:" v-if="connectMerchantHistory.length > 0">
                    <div class="merchant-history">
                        <span v-for="item in connectMerchantHistory" :key="item.id" class="history-item"
                            @click="selectHistoryMerchant(item)">
                            {{ item.companyName }}
                        </span>
                    </div>
                </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button @click="connectMerchantDialog = false">取消</el-button>
                <el-button type="primary" @click="submitConnectMerchant">确定</el-button>
            </span>
        </el-dialog>

        <!-- 关联合作客户对话框 -->
        <el-dialog :visible.sync="connectCoreCustomerDialog" width="500px" title="关联合作客户" :close-on-click-modal="false">
            <el-form label-width="100px">
                <el-form-item label="选择合作客户:">
                    <el-select filterable clearable v-model="connectCoreCustomerId" placeholder="请选择合作客户"
                        style="width: 100%;">
                        <el-option v-for="item in connectCoreCustomerList" :key="item.id" :label="item.companyName"
                            :value="item.id">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="历史记录:" v-if="connectCoreCustomerHistory.length > 0">
                    <div class="merchant-history">
                        <span v-for="item in connectCoreCustomerHistory" :key="item.id" class="history-item"
                            @click="selectHistoryCoreCustomer(item)">
                            {{ item.companyName }}
                        </span>
                    </div>
                </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button @click="cancelConnectCoreCustomer" v-if="connectCoreCustomerId">取消关联客户</el-button>
                <el-button @click="connectCoreCustomerDialog = false">取消</el-button>
                <el-button type="primary" @click="submitConnectCoreCustomer">确定</el-button>
            </span>
        </el-dialog>

    </div>
</template>

<script>
import {
    orderdetail,
    upadateorderapplicants,
    addorderapplicants,
    orderapplcantstatusselect,
    queryorderapplicants,
    orderapplicantmodifystatus,
    orderapplicantmodifyidentity,
    downloadapplicantsdata,
    orderapplicantremarks,
    uploadvisapage,
    batchsubmitapplicant,
    paycallback,
    paycallbackloop,
    applicantstatus,
    batchcancelvfsorder,
    upadateorderdeparturetime,
    batchextractpassport,
    checkpassportinfos,
    seachorderapplicantemailhistory,
    cancelpay,
    seachnewemaildata,
    connectmerchant,
    connectcorecustomer
} from "@/api/order.js";
import {
    orderremarks,
    delorderapplicant,
    getsystemvisa,
} from "@/api/orderCenter.js";
import {
    accountlist,
    queryorderretransactionrecord,
    addretransactionrecord,
    cancelorderretransactionrecord,
    addorderretransactionrecord,
    querycorecustomers
} from "@/api/finance.js";
import alyoss from "@/utils/alyoss";
import addUserInfoTwo from "@/components/addUserInfoTwo.vue";
import uploadTwo from "@/components/uploadTwo.vue";
import upload from "@/components/upload.vue";
import batchApplication from "../../../components/batchApplication.vue";
import batchApplicationSubmit from "../../../components/batchApplicationSubmit.vue";
import informationsApplication from "./components/informationsApplication";
import orderQRCodeDialog from "../components/orderQRCodeDialog.vue";
import { getSessionStorage, setSessionStorage, getToken } from "@/utils/auth";
import { merchant } from "@/api/settings.js";
const cityOptions = ["收据页", "签证文件", "拒签信"];
export default {
    data() {
        return {
            name: "",
            userType: "",
            applicationForm: {},
            id: "",
            identityType: "",
            textarea: "",
            sfObj: {},
            checkedCities: ["收据页", "签证文件", "拒签信"],
            statusSelect: [],
            userList: [],
            userListAllTable: [],
            isVisible: false,
            isUp: false,
            cities: cityOptions,
            newAddUserShow: false,
            applicationName: '',
            pageIndex: 1,
            pageSize: 10,
            Status: -99,
            checkAll: true,
            isIndeterminate: false,
            changeStatusShow: false,
            changeStatusType: "",
            changeStatusTime: "",
            changeStatusData: {

            },
            total: 0,
            downList: {
                pageIndex: 1,
                pageSize: 1000,
                title: ''
            },
            orderDetail: {
                order: {},
                orderApplicants: [],
                visaDetail: {
                    basicInfo: [],
                    offlineVisaDocs: [],
                    visa: {},
                    visaDocs: [],
                },
            },
            dateInfo: {
                date: "",
            },
            colors: [
                { color: "#E41313", percentage: 50 },
                { color: "#EEBB17", percentage: 99 },
                { color: "#1C9C1C", percentage: 100 },
            ],
            isShow: true,
            tableActive: 0,
            userId: "",
            dowmShow: false,
            beizhuShow: false,
            tjShow: false,
            beizhuId: "",
            uploadLoading: false, // 是否点击批量下载
            submitLoading: false, // 是否点击提交
            submitIngStatus: 10, // 提交中状态
            applicantstatusTimer: null,
            applicantstatusTimerPay: null, // 支付状态定时器
            submitIngStatusPay: 12, // 支付中状态
            submitIngStatusCancelPay: 24, // 取消支付中状态
            applicationLoading: false,
            submitApplicationShow: false,
            iframeUrl: "",//iframe链接地址
            isBatch: false,//是否批量提交
            vfs: 0, //判断是什么国家
            vfsList: [7, 9, 11, 12, 13, 14, 15, 16, 17, 21, 22, 23], //能取消的签证国家
            isQrcodeImg: false,

            activeName: 'second',
            applicantLoading: false,
            currentRequestId: 0, // 当前请求的唯一标记
            showMarksDialog: false,
            adminUserId: '', // 当前操作人的id
            showEmailPop: false,
            expandStatus: [], // 动态存储每封邮件的展开状态（数组索引对应邮件索引）
            // 模拟多封邮件数据（可根据实际接口返回替换）
            emailList: [],
            emailLoading: false,
            seachEmailHistory: false,
            canCancelPay: false,
            showFormType: '',
            // 收款相关
            visibleReceive: false,
            visibleAddReceive: false,
            receiveId: 0,
            isEdit: false,
            receiveLoading: false,
            accountList: [],
            receiveList: [],
            query: {
                id: '',
                orderNo: '',
                createdTime: '',
                serviceMarks: '',
                merchantName: '',
                coreCustomerName: '',
                payableAmount: 0,
                orgPayableAmount: 0,
                paidAmount: 0,
                userId: '',
                isPaid: true,
                merchantId: '',
                accountId: '',
                status: true,
            },
            // 关联商户相关
            connectMerchantDialog: false,
            connectOrderId: '',
            connectMerchantId: '',
            connectMerchantList: [],
            connectMerchantHistory: [],
            // 关联合作客户相关
            connectCoreCustomerDialog: false,
            connectCoreCustomerId: '',
            connectCoreCustomerList: [],
            connectCoreCustomerHistory: [],
            addReceiveForm: {
                amount: '',
                accountId: '',
                remark: '',
                imageUrl: '',
            },
            addReceiveFormRules: {
                amount: [
                    { required: true, message: '请输入金额', trigger: 'blur' },
                    { pattern: /^\d+(\.\d+)?$/, message: '请输入有效的数字金额', trigger: 'blur' }
                ],
                accountId: [
                    { required: true, message: '请选择账户', trigger: 'change' }
                ],
            },
        }
    },
    components: {
        addUserInfoTwo,
        uploadTwo,
        upload,
        batchApplication,
        batchApplicationSubmit,
        informationsApplication,
        orderQRCodeDialog
    },
    watch: {
        applicationForm: {
            deep: true,
            immediate: true,
            handler(val, oldVal) {
                if (
                    val &&
                    val.applicationForm
                ) {
                    this.isShow = false;

                    // val.applicationForm = val.applicationForm.replace('https://visa-application-form.sport-syy.com', 'http://localhost:8081')
                    // 使用$nextTick确保iframe已销毁
                    this.$nextTick(() => {
                        this.isShow = true;
                        // 再设置新的url，触发iframe重建
                        this.iframeUrl = val.applicationForm + "&terminal=PC&?v=" + new Date().getTime() + '&userId=' + this.adminUserId
                    });
                }
            },
        },
    },
    created() {
        let prePage = sessionStorage.getItem("km_userInfoPage") || "{}"
        if (prePage) {
            let prePageInfo = JSON.parse(prePage)
            if (prePageInfo.page && prePageInfo.pageSize) {
                this.addressCurrentChange(Math.ceil(prePageInfo.page * prePageInfo.pageSize / this.pageSize))
                sessionStorage.removeItem("km_userInfoPage")
            }
        }

        // 初始化展开状态：所有邮件默认收起
        this.expandStatus = new Array(this.emailList.length).fill(false);
    },
    mounted() {
        this.name = this.$router.history.current.params.id.split("_")[0] == "name" ? null : this.$router.history.current.params.id.split("-")[0];
        this.userType = this.$router.history.current.params.id.split("_")[1] == "type" ? null : this.$router.history.current.params.id.split("-")[1];
        this.id = this.$router.history.current.params.id.split("-")[2];
        this.vfs = Number(this.$router.history.current.params.id.split("-")[4]);
        this.userId = sessionStorage.getItem("km_userId") || 0;

        console.log(this.$router, this.userId, this.$router.history.current.params, sessionStorage.getItem("km_userId"))
        this.orderdetailFn();
        this.queryorderapplicantsFn();
        var that = this;
        window.addEventListener("message", function (event) {
            if (event.data == "刷新进度") {
                that.queryorderapplicantsFn();
            }
        });
        this.orderapplcantstatusselectFn()
        // 查询绑定后台用户id
        this.queryBindUserId()
        this.getsystemvisa();
    },
    computed: {
        setStatus() {
            return function (status) {
                if (status == -4 || status == -2 || status == -3 || status == 2) {
                    return "sty-red";
                } else if (status == 0 || status == 1 || status == 3) {
                    return "sty-blue";
                } else {
                    return "sty-yello";
                }
            };
        },
        setTopClass() {
            return function (identityType) {
                if ([0, 2, 14, 6, 11, 18].indexOf(identityType) >= 0) {
                    return "color:#eebb17"; //黄色
                } else if ([8, 10, 12, 16].indexOf(identityType) >= 0) {
                    return "color:#1c9c1c"; //绿色
                } else {
                    return "color:#e41313"; //红色
                }
            };
        },
        setOrderSourceText() {
            return function (num) {
                let str = "";
                switch (num) {
                    case 0:
                        str = "商";
                        break;
                    case 1:
                        str = "平";
                        break;
                    case 2:
                        str = "用";
                        break;
                    default:
                        str = "接";
                }
                return str;
            };
        },
        setOrderSourceColor() {
            return function (num) {
                let str = "";
                switch (num) {
                    case 0:
                        str = "#4791EA";
                        break;
                    case 1:
                        str = "#49BD49";
                        break;
                    case 2:
                        str = "#F79534";
                        break;
                    default:
                        str = "#EA4747";
                }
                return str;
            };
        },
    },
    methods: {
        // 收款相关方法
        openReceive(item) {
            this.visibleReceive = true
            this.receiveId = item.id
            this.isEdit = item.payableAmount == 0 ? true : false
            this.query = {
                id: item.id,
                orderNo: item.orderNo,
                createdTime: item.createdTime,
                serviceMarks: item.serviceMarks,
                merchantName: item.merchantName || '',
                merchatId: item.merchatId || '',
                coreCustomerName: item.coreCustomerName || '',
                coreCustomerId: item.coreCustomerId || '',
                payableAmount: item.payableAmount,
                orgPayableAmount: item.payableAmount,
                paidAmount: item.paidAmount,
                userId: item.userId,
                isPaid: true,
                accountId: '',
                status: true,
            }
            accountlist().then(res => {
                this.accountList = res.data.map(t => {
                    return {
                        label: t.accountName,
                        value: t.id,
                    }
                });
            })
            this.getQueryretransactionrecord()
        },
        getQueryretransactionrecord() {
            this.receiveLoading = true;
            queryorderretransactionrecord({
                orderId: this.query.id,
            }).then(res => {
                this.receiveLoading = false;
                if (res.code == 1) {
                    this.receiveList = res.data
                    this.total = res.data.total
                } else {
                    this.$message({
                        message: res.msg,
                        type: "warning",
                    });
                }
            })
        },
        cancelEdit() {
            this.isEdit = !this.isEdit
            this.query.payableAmount = this.query.orgPayableAmount
        },
        saveReceive() {
            addorderretransactionrecord({
                accountId: this.query.isPaid ? this.query.accountId : 0,
                isPaid: this.query.isPaid,
                payableAmount: this.query.payableAmount,
                orderId: this.query.id,
            }).then(res => {
                if (res.code == 1) {
                    this.$message({
                        message: "操作成功！",
                        type: "success",
                    });
                    this.isEdit = false
                    this.getQueryretransactionrecord();
                    this.orderdetailFn().then(() => {
                        this.openReceive(this.orderDetail.order)
                    });;
                } else {
                    this.$message({
                        message: res.msg,
                        type: "warning",
                    });
                }
            })
        },
        // 关联商户
        openConnectMerchant(row) {
            this.connectOrderId = row.id;
            this.connectMerchantId = row.merchatId || '';
            merchant({}).then(res => {
                if (res.code == 1) {
                    this.connectMerchantList = res.data.rows || [];
                }
            });
            this.loadMerchantHistory();
            this.connectMerchantDialog = true;
        },
        loadMerchantHistory() {
            try {
                const history = localStorage.getItem('merchantHistory');
                if (history) {
                    this.connectMerchantHistory = JSON.parse(history);
                } else {
                    this.connectMerchantHistory = [];
                }
            } catch (e) {
                this.connectMerchantHistory = [];
            }
        },
        saveMerchantHistory(merchant) {
            this.connectMerchantHistory = this.connectMerchantHistory.filter(item => item.id !== merchant.id);
            this.connectMerchantHistory.unshift(merchant);
            this.connectMerchantHistory = this.connectMerchantHistory.slice(0, 10);
            localStorage.setItem('merchantHistory', JSON.stringify(this.connectMerchantHistory));
        },
        selectHistoryMerchant(item) {
            this.connectMerchantId = item.id;
        },
        submitConnectMerchant() {
            if (!this.connectMerchantId) {
                return this.$message.error('请选择商户');
            }
            connectmerchant({
                orderId: this.connectOrderId,
                merchantId: this.connectMerchantId
            }).then(res => {
                if (res.code == 1) {
                    this.$message.success('关联成功');
                    const selectedMerchant = this.connectMerchantList.find(item => item.id === this.connectMerchantId);
                    if (selectedMerchant) {
                        this.saveMerchantHistory(selectedMerchant);
                    }
                    this.connectMerchantDialog = false;
                    this.orderdetailFn().then(() => {
                        this.openReceive(this.orderDetail.order);
                    });
                } else {
                    this.$message.error(res.msg || '关联失败');
                }
            });
        },
        // 关联合作客户
        openConnectCoreCustomer(row) {
            this.connectOrderId = row.id;
            this.connectCoreCustomerId = row.coreCustomerId || '';
            querycorecustomers({}).then(res => {
                if (res.code == 1) {
                    this.connectCoreCustomerList = res.data.rows || [];
                }
            });
            this.loadCoreCustomerHistory();
            this.connectCoreCustomerDialog = true;
        },
        loadCoreCustomerHistory() {
            try {
                const history = localStorage.getItem('coreCustomerHistory');
                if (history) {
                    this.connectCoreCustomerHistory = JSON.parse(history);
                } else {
                    this.connectCoreCustomerHistory = [];
                }
            } catch (e) {
                this.connectCoreCustomerHistory = [];
            }
        },
        saveCoreCustomerHistory(customer) {
            this.connectCoreCustomerHistory = this.connectCoreCustomerHistory.filter(item => item.id !== customer.id);
            this.connectCoreCustomerHistory.unshift(customer);
            this.connectCoreCustomerHistory = this.connectCoreCustomerHistory.slice(0, 10);
            localStorage.setItem('coreCustomerHistory', JSON.stringify(this.connectCoreCustomerHistory));
        },
        selectHistoryCoreCustomer(item) {
            this.connectCoreCustomerId = item.id;
        },
        submitConnectCoreCustomer() {
            connectcorecustomer({
                orderId: this.connectOrderId,
                coreCustomerId: this.connectCoreCustomerId || 0
            }).then(res => {
                if (res.code == 1) {
                    this.$message.success('关联成功');
                    if (this.connectCoreCustomerId) {
                        const selectedCustomer = this.connectCoreCustomerList.find(item => item.id === this.connectCoreCustomerId);
                        if (selectedCustomer) {
                            this.saveCoreCustomerHistory(selectedCustomer);
                        }
                    }
                    this.connectCoreCustomerDialog = false;
                    this.orderdetailFn().then(() => {
                        this.openReceive(this.orderDetail.order);
                    });
                } else {
                    this.$message.error(res.msg || '关联失败');
                }
            });
        },
        // 取消关联合作客户
        cancelConnectCoreCustomer() {
            this.$confirm('确认要取消关联客户吗?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                connectcorecustomer({
                    orderId: this.connectOrderId,
                    coreCustomerId: 0
                }).then((res) => {
                    if (res.code == 1) {
                        this.$message.success('操作成功');
                        this.connectCoreCustomerDialog = false;
                        this.orderdetailFn().then(() => {
                            this.openReceive(this.orderDetail.order);
                        });
                    } else {
                        this.$message.error(res.msg || '操作失败');
                    }
                })
            })
        },
        handleAmountInput() {
            this.addReceiveForm.amount = this.addReceiveForm.amount.toString().replace(/[^\d.]/g, '');
            const parts = this.addReceiveForm.amount.split('.');
            if (parts.length > 2) {
                this.addReceiveForm.amount = parts[0] + '.' + parts.slice(1).join('');
            }
            if (parts[1] && parts[1].length > 2) {
                this.addReceiveForm.amount = parts[0] + '.' + parts[1].substring(0, 2);
            }
        },
        saveAddReceive() {
            this.$refs.addReceiveFormRef.validate(valid => {
                if (valid) {
                    addretransactionrecord({
                        accountId: this.addReceiveForm.accountId,
                        isPaid: true,
                        amount: this.addReceiveForm.amount,
                        userId: this.query.userId,
                        merchantId: this.query.merchantId,
                        remark: this.addReceiveForm.remark,
                        orderId: this.query.id,
                        imageUrl: this.addReceiveForm.imageUrl,
                    }).then(res => {
                        if (res.code == 1) {
                            this.$message({
                                message: "操作成功！",
                                type: "success",
                            });
                            this.getQueryretransactionrecord();
                            this.orderdetailFn().then(() => {
                                this.openReceive(this.orderDetail.order)
                            });;
                        } else {
                            this.$message({
                                message: res.msg,
                                type: "warning",
                            });
                        }
                    })
                    this.visibleAddReceive = false;
                    this.addReceiveForm = {
                        amount: '',
                        accountId: '',
                        remark: '',
                        imageUrl: '',
                    };
                } else {
                    return false;
                }
            });
        },
        cancelReceive(item) {
            this.$confirm('确认要取消收款吗?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                cancelorderretransactionrecord({
                    id: item.id,
                    orderId: this.query.id
                }).then(res => {
                    if (res.code == 1) {
                        this.$message({
                            message: '操作成功',
                            type: 'success'
                        })
                        setTimeout(() => {
                            this.getQueryretransactionrecord()
                            this.orderdetailFn().then(() => {
                                this.openReceive(this.orderDetail.order)
                            });

                        }, 0);
                    }
                })
            }).catch(() => {
                this.$message({
                    message: '已取消操作',
                    type: 'info'
                });
            });
        },
        toImg(event, field) {
            this.addReceiveForm[field] = event;
        },
        seachnewemaildata() {
            this.emailLoading = true;
            seachnewemaildata({
                orderApplicantId: this.applicationForm.id,
            }).then(res => {
                if (res.code == 1) {
                }
            }).catch(() => {

            })
            setTimeout(() => {
                this.reportsuccess();
            }, 5000);
        },
        reportsuccess() {
            this.showEmailPop = true;
            this.emailLoading = true;
            seachorderapplicantemailhistory({
                orderApplicantId: this.applicationForm.id,
            }).then(res => {
                if (res.code == 1) {
                    this.emailLoading = false;
                    this.emailList = res.data.rows;
                    // 重新初始化expandStatus数组，确保与邮件列表长度匹配
                    this.expandStatus = new Array(this.emailList.length).fill(false);
                }
            }).catch(() => {
                this.emailLoading = false;
            })
        },
        // 切换邮件展开/收起状态
        toggleEmailExpand(index) {
            this.expandStatus[index] = !this.expandStatus[index];
            // 强制更新视图
            this.$forceUpdate();
        },
        cancelpay() {
            this.$confirm('是否确定取消支付?', '取消支付', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                this.applicationForm.status = this.submitIngStatusCancelPay;
                cancelpay({
                    orderApplicantId: this.applicationForm.id,
                }).then(res => {
                    if (res.code == 1) {
                        this.$message.success('已取消支付');
                        this.queryorderapplicantsFn();
                    }
                }).catch(() => {
                    this.applicationForm.status = 12;
                })
            }).catch(() => {

            });


        },
        getsystemvisa() {
            console.log(this.orderId, '111111')
            getsystemvisa({
                orderId: this.id,

            }).then(res => {
                if (res.code == 1) {
                    this.seachEmailHistory = res.data.seachEmailHistory;
                    this.canCancelPay = res.data.canCancelPay;
                    console.log(this.canCancelPay, "取消支付")
                    // 保存到全局状态管理
                    this.$store.commit('SET_VISA_DATA', res.data);
                }
            })

        },

        // 点击复制内容
        async handleCopy(content) {

            if (!content) {
                return
            }
            try {
                // 使用 Clipboard API 写入文本到剪贴板
                await navigator.clipboard.writeText(content);
                // 复制成功提示
                this.$message.success('复制成功');
            } catch (err) {
                // 复制失败处理
                console.error("复制失败:", err);
            }
        },
        // 查询用户列表
        queryApplicantsList() {
            queryorderapplicants({
                key: this.applicationName,
                OrderId: this.id,
                "Page.Size": this.pageSize,
                "Page.Index": this.pageIndex,
                orgQuery: true,
                Status: this.Status == -99 ? '' : this.Status,
            }).then(res => {
                if (res.code == 1) {
                    let keys = Object.keys(this.timmerObject)
                    let arr = res.data.rows.filter(item => keys.includes(item.id.toString()))
                    arr.forEach(item => {
                        if (item.status != this.timmerObject[item.id].status) {
                            let currentIndex = this.userList.findIndex(item2 => item2.id == item.id)
                            this.userList[currentIndex].status = item.status
                            this.userList[currentIndex].statusName = item.statusName
                            this.$forceUpdate()
                            delete this.timmerObject[item.id]
                        }
                    })
                }
            })
        },
        async queryBindUserId() {
            let data = await getSessionStorage('orgAuthInfo')
            if (data) {
                this.adminUserId = data.userId
            }
        },
        handleFilterChange(value) {
            console.log(value)
            // 点击修改状态重新请求申请人列表
            this.Status = value;
            this.pageIndex = 1;
            this.queryorderapplicantsFn();
        },
        //单个取消
        cancelStatus(item) {
            let orderApplicantIds = [item.id];
            batchcancelvfsorder({ orderApplicantIds: orderApplicantIds }).then((res) => {
                if (res.code == 1) {
                    this.$message({
                        message: `${this.applicantstatusTimer}`,
                        type: "success",
                    });
                    this.queryorderapplicantsFn();
                    if (this.applicantstatusTimer) {
                        clearInterval(this.applicantstatusTimer);
                        this.applicantstatusTimer = null;
                    }
                }
            })
        },
        // 修改出行时间等
        openChangeTime(item, type) {
            console.log(item)
            this.changeStatusType = type
            this.changeStatusData.orderId = item.id
            // 目前只有出行时间
            // this.changeStatusData.departureTime = item.departureTime
            this.changeStatusTime = item.departureTime
            this.changeStatusShow = true
        },
        // 提交修改
        changeStatusSubmit() {
            let data = {
                orderId: this.changeStatusData.orderId,
                departureTime: this.changeStatusTime
            }
            upadateorderdeparturetime(data).then(res => {
                if (res.code == 0) {
                    this.$message({
                        message: res.msg,
                        type: "warning",
                    });
                } else {
                    this.$message({
                        message: "操作成功！",
                        type: "success",
                    });
                    this.orderDetail.order.departureTime = this.changeStatusTime;
                    this.changeStatusShow = false;
                }
            })
        },
        handleClose() { },
        getUser(e) {
            this.userListAllTable = e;
        },
        getRowKeys(val) {
            return val.id || "";
        },
        clickSubmit(a, b, c) {
            console.log(this.applicationForm);
            console.log(a, b, c);

            // autoSubmitStatus-1时就是重新提交不需要再次支付，直接提交
            if (
                this.applicationForm.status == 20 &&
                this.applicationForm.autoSubmitStatus == -1
            ) {
                // 重新提交
                this.confirmSubmit(false);
            } else if (this.applicationForm.status == 12) {
                this.openPay(this.applicationForm);
            } else if (this.applicationForm.status == 16) {
                window.open(this.applicationForm.visaPage);
            } else if (this.applicationForm.status == 14) {
                // 上传签证页
                // this.$refs.uploadRef.$el.querySelector('input').click()
            } else if (this.applicationForm.isPay == 0) {
                //isPay0时需要支付
                this.isBatch = false;
                // 选择支付方式提交大使馆
                this.submitApplicationShow = true;

                this.tjShow = false;
                this.dowmShow = false;
            } else {
                // this.isBatch = false;
                // // 选择支付方式提交大使馆
                // this.submitApplicationShow = true;

                // this.tjShow = false;
                // this.dowmShow = false;
                this.confirmSubmit(false);
            }
        },

        // 提交大使馆(isBatch=true批量提交|单个申请人提交 | payType支付方式 | userListAllTable勾选的申请人)
        confirmSubmit(isBatch, payType, userListAllTable = []) {
            if (this.submitLoading) {
                return;
            }
            this.submitLoading = true;

            // 关闭其他弹窗
            this.isBatch = false;
            this.tjShow = false;
            this.dowmShow = false;

            let arr = [];
            if (isBatch) {
                arr = userListAllTable.map(item => item.id);
            } else {
                arr = [this.applicationForm.id];
            }

            // 备份操作申请人信息
            let applicationFormCopy = JSON.parse(JSON.stringify(this.applicationForm))

            batchsubmitapplicant({
                payType,
                orderApplicantIds: arr,
            }).then((res) => {
                this.submitLoading = false;

                if (res.data[0].successful) {
                    this.$message({
                        message: "提交成功！",
                        type: "success",
                    });
                } else {
                    this.$message({
                        message: res.data[0].msg,
                        type: "warning",
                    });
                }
                sessionStorage.removeItem("km_userId");
                //this.orderdetailFn();
                setTimeout(() => {
                    this.queryorderapplicantsFn();
                }, 3800);

                let findIndex = this.userList.findIndex((item) => {
                    return item.id == arr[0];
                });
                if (findIndex > -1) {
                    this.userList[findIndex].status = this.submitIngStatus;
                    this.userList[findIndex] = { ...this.userList[findIndex] };
                    this.userList = [...this.userList];
                }
                applicationFormCopy.status = this.submitIngStatus;
                if (applicationFormCopy.id == arr[0]) {
                    applicationFormCopy.status = this.submitIngStatus;
                    // 提交中状态轮询查询订单状态
                    this.clickApplicantStatus(applicationFormCopy);
                }
                if (isBatch) {
                    location.reload();
                }
            })
                .catch(() => {
                    this.submitLoading = false;
                    if (isBatch) {
                        location.reload();
                    }
                });

        },
        openStatusFn(item) {
            let vm = this;

            vm.$router.push({
                name: "information",
                params: { information: item.id, id: `${this.id}_${item.id}` },
            });
        },

        copySuccess() {
            this.$message({
                message: "复制成功！",
                type: "success",
            });
        },
        copyError() {
            this.$message({
                message: "复制失败，请手动复制！",
                type: "error",
            });
        },

        delUser() {
            console.log(this.applicationForm, this.userId)
            var index = 0;
            this.orderDetail.orderApplicants.forEach((item, idx) => {
                if (item.id == this.applicationForm.id) {
                    index = idx;
                }
            });

            this.$confirm(`是否要要删除该申请人`, "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
            })
                .then(() => {
                    this.orderDetail.orderApplicants.splice(index, 1);
                    let oldArr = [];
                    this.orderDetail.orderApplicants.forEach((item) => {
                        oldArr.push({
                            applicantName: item.applicantName,
                            identityTypeId: item.identityType,
                            id: item.id,
                        });
                    });

                    let arr = [...oldArr];
                    delorderapplicant({
                        Id: this.userId,
                    }).then((res) => {
                        if (res.code == 1) {
                            this.$message({
                                message: "删除成功！",
                                type: "success",
                            });
                            sessionStorage.removeItem("km_userId");
                            this.userId = 0;
                            this.orderdetailFn();
                            setTimeout(() => {
                                this.queryorderapplicantsFn();
                            }, 500);
                        }
                    });
                })
                .catch((res) => { });
        },
        orderdetailFn() {
            let vm = this;

            return orderdetail({
                id: vm.id,
            }).then((res) => {
                vm.orderDetail = res.data;
                vm.dateInfo.date =
                    vm.orderDetail.order &&
                    vm.orderDetail.order.departureTime &&
                    vm.orderDetail.order.departureTime.split(" ")[0];

                if (vm.orderDetail.order && vm.orderDetail.order.embassyDate) {
                    vm.orderDetail.order.embassyDate = JSON.parse(
                        vm.orderDetail.order.embassyDate
                    );

                    if (vm.orderDetail.order.embassyDate.label == "近30天内均无法前往") {
                        vm.orderDetail.order.embassyDate.str =
                            vm.orderDetail.order.embassyDate.value[0];
                    } else if (
                        vm.orderDetail.order.embassyDate.label == "指定最佳赴馆时间前往"
                    ) {
                        vm.orderDetail.order.embassyDate.str =
                            vm.orderDetail.order.embassyDate.value.join("、");
                    } else {
                        vm.orderDetail.order.embassyDate.str =
                            vm.orderDetail.order.embassyDate.label;
                    }
                }
                vm.textarea = vm.orderDetail.order.serviceMarks
                // // 生成小程序关联订单二维码
                // vm.getQrcodeFn();
                // // 判断是否为人工代填
                // if(this.orderDetail.order.visaTitle.indexOf('人工代填') > -1 ) {
                //   this.drawer = true
                // } else {
                //   this.drawer = false
                // }
            });
        },

        toImg(e) {
            uploadvisapage({
                orderApplicantId: this.beizhuId,
                visaPage: e,
            }).then((res) => {
                this.$message({
                    message: "上传成功！",
                    type: "success",
                });
            });
        },
        async uploadVisapage(file) {
            let alyossData = await alyoss(file.file);
            uploadvisapage({
                orderApplicantId: this.applicationForm.id,
                visaPage: alyossData,
            }).then((res) => {
                if (res.code === 1) {
                    this.$message({
                        message: "上传成功！",
                        type: "success",
                    });
                    this.queryorderapplicantsFn();
                }
            });
        },

        orderapplcantstatusselectFn() {
            orderapplcantstatusselect({}).then((res) => {
                console.log(res, 11111111111)
                this.statusSelect = res.data
            });
        },

        selectIdentit(e, item) {
            // this.editSf(e, item)
            orderapplicantmodifyidentity({
                orderApplicantId: item.id,
                status: item.status,
                identityTypeId: e,
            }).then((res) => {
                this.$message({
                    message: "修改成功！",
                    type: "success",
                });
            });
        },

        loadReast() {
            this.queryorderapplicantsFn();
        },

        submitBz() {
            orderapplicantremarks({
                orderApplicantId: this.beizhuId,
                remarks: this.textarea,
            }).then((res) => {
                this.$message({
                    message: "备注成功！",
                    type: "success",
                });
                this.beizhuShow = false;
            });
        },
        submitTextareaFn() {
            orderremarks({
                orderId: this.orderDetail.order.id,
                remarks: this.textarea,
            }).then((res) => {
                this.orderdetailFn()
                this.orderDetail.order.serviceMarks = this.textarea;
                this.showMarksDialog = false;
                this.$message.success("修改备注成功！");
            }).catch(() => {
                this.showMarksDialog = false;
            });
        },
        handleCommand(e) {
            this.dowmShow = false;
            this.tjShow = false;
            if (e == "a") {
                // 批量下载
                this.dowmShow = true;
                this.downList.orderId = this.id,
                    this.$refs.batchApplicationRef.getQueryorderapplicants(this.downList);
            } else if (e == "b") {
                this.downList.title = "批量提交";

                // 备份当前操作申请人信息
                let applicationFormCopy = JSON.parse(JSON.stringify(this.applicationForm))

                this.tjShow = true;


                setTimeout(() => {
                    this.$refs.batchApplicationRef.getQueryorderapplicants({
                        orderId: this.id,
                        pageIndex: 1,
                        pageSize: this.total
                    });
                }, 500);
            } else if (e == "d") {
                this.downList.title = "批量取消"
                this.tjShow = true;
                this.$refs.batchApplicationRef.getQueryorderapplicants({
                    orderId: this.id,
                    pageIndex: 1,
                    pageSize: this.total
                });
            } else if (e == "e") {
                this.downList.title = "发送邮件"
                this.tjShow = true;
                this.$refs.batchApplicationRef.getQueryorderapplicants({
                    orderId: this.id,
                    pageIndex: 1,
                    pageSize: this.total
                });
            } else if (e == "c") {
                this.queryorderapplicantsFn();
            } else if (e == "f") {
                // 导出名单
                this.downList.title = "导出名单"
                this.tjShow = true;
                this.$refs.batchApplicationRef.getQueryorderapplicants({
                    orderId: this.id,
                    pageIndex: 1,
                    pageSize: this.total
                });
            } else if (e == 'g') {
                // 扣出用户高清头像 弹窗确认是否执行操作
                this.$confirm('是否批量将用户护照高清头像填入到用户数据中？', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    batchextractpassport({ orderId: this.id }).then(res => {
                        if (res.code == 1) {
                            this.$message({
                                message: '操作成功',
                                type: 'success'
                            });
                            this.queryorderapplicantsFn();
                        }
                    })
                }).catch(() => {

                });
            } else if (e == 'h') {
                // 批量核验数据
                this.$confirm('是否批量核验用户护照数据？', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    checkpassportinfos({ orderId: this.id }).then(res => {
                        if (res.code == 1) {
                            this.$message({
                                message: '操作成功',
                                type: 'success'
                            });
                            this.queryorderapplicantsFn();
                        }
                    })
                }).catch(() => {

                });
            }
            else {
                location.reload();
            }

        },
        setHandleCommand(e, item) {
            if (e == "a") {
                this.beizhuId = item.id;
            } else if (e == "b") {
                // downloadapplicantsdata({
                //     orderApplicantIds: [item.id],
                //     visaPage: true,
                //     rejectLetter: true,
                //     bill: true,
                // }).then(res => {
                //     if(res.code==0){
                //         this.$message({
                //             message: res.msg,
                //             type: 'warning'
                //         });
                //     }else{
                //         window.open(res.data)
                //         this.urlDownload(res.data);
                //     }
                // })

                // window.open(item.visaPage);
                let that = this;
                const url = item.visaPage
                let x = new XMLHttpRequest();
                x.open("GET", url, true);
                x.responseType = "blob";
                x.onload = function () {
                    let url = window.URL.createObjectURL(x.response);
                    let a = document.createElement("a");
                    a.href = url;
                    a.download = item.applicantName + "_" + that.orderDetail.order.visaTitle + "_" + that.$moment(new Date()).format("YYYYMMDDHHmmss");
                    a.click();
                };
                x.send();

            } else if (e == 'c') {
                let that = this;
                const url = item.rejectLetter
                let x = new XMLHttpRequest();
                x.open("GET", url, true);
                x.responseType = "blob";
                x.onload = function () {
                    let url = window.URL.createObjectURL(x.response);
                    let a = document.createElement("a");
                    a.href = url;
                    a.download = item.applicantName + "_" + that.orderDetail.order.visaTitle + "_" + that.$moment(new Date()).format("YYYYMMDDHHmmss");
                    a.click();
                };
                x.send();
            } else {
                this.openStatusFn(item);
                // this.loadReast();
            }
        },

        urlDownload(url, fileName = "下载文件") {
            // 创建隐藏的可下载链接
            let eleLink = document.createElement("a");
            eleLink.download = fileName;
            eleLink.style.display = "none";
            eleLink.href = url;
            // 触发点击
            document.body.appendChild(eleLink);
            eleLink.click();
            // 然后移除
            document.body.removeChild(eleLink);
        },

        queryorderapplicantsFn(isTableLoading) {
            if (isTableLoading) {
                this.applicationLoading = true;
            }
            queryorderapplicants({
                key: this.applicationName,
                OrderId: this.id,
                "Page.Size": this.pageSize,
                "Page.Index": this.pageIndex,
                orgQuery: true,
                Status: this.Status == -99 ? '' : this.Status,
            })
                .then((res) => {
                    this.total = res.data.total;
                    this.userList = res.data.rows;
                    if (this.userId > 0) {
                        this.userList.forEach((item) => {
                            if (item.id == this.userId) {
                                this.applicationForm = item;
                                this.userId = item.id;
                                this.setColl(item);
                                this.$nextTick(() => {
                                    this.$refs.tableOrder &&
                                        this.$refs.tableOrder.setCurrentRow(item);
                                });
                                // 提交中状态轮询查询订单状态
                                this.clickApplicantStatus(this.applicationForm);
                            }
                        });
                    } else {
                        this.applicationForm = this.userList[0] || {};
                        this.setColl(this.userList[0]);
                        this.$nextTick(() => {
                            this.$refs.tableOrder &&
                                this.$refs.tableOrder.setCurrentRow(this.userList[0]);
                        });
                        // 提交中状态轮询查询订单状态
                        this.clickApplicantStatus(this.applicationForm);
                    }
                    this.applicationLoading = false;
                })
                .catch(() => {
                    this.applicationLoading = false;
                });
        },

        uploadHandle(val) {
            var vm = this;

            vm.uploading = val;
        },

        toPath(num) {
            if (num == 1) {
                // this.$router.push({ name: 'index' })
                this.$router.push({ name: "home" });
            }

            if (num == 2) {
                this.$router.push({ name: "orderCenter" });
            }

            if (num == 3) {
                // this.$router.push({ name: 'order-id', params: { id: this.id } })
                // this.$router.go(-1)
            }
        },
        selectStatus(e, item) {
            orderapplicantmodifystatus({
                orderApplicantId: item.id,
                status: e,
            }).then((res) => {
                this.$message({
                    message: "修改成功！",
                    type: "success",
                });
                this.queryorderapplicantsFn();
            });
        },
        reload() {
            this.isShow = false;
            // 使用$nextTick确保iframe已销毁
            this.$nextTick(() => {
                this.isShow = true;
            });

        },
        iframeSubmit() {
            if (this.iframeSubmitThrottling) return;
            this.iframeSubmitThrottling = true;
            this.$refs.iframeRef.contentWindow.postMessage(this.userId, "*");
            setTimeout(() => {
                this.iframeSubmitThrottling = false;
            }, 2000);
        },
        iframeUpdate() {
            this.$refs.iframeRef.contentWindow.postMessage({
                type: "update",
                passengerId: this.userId
            }, "*");
        },
        addressCurrentChange(e) {
            this.pageIndex = e;

            this.queryorderapplicantsFn();
        },
        editPackage(item) {
            this.isVisible = true;
            this.sfObj = item;
        },

        toPayDetail(item) {
            this.$router.push({
                name: "orderInfoDetails",
                params: { details: this.id },
            });
        },

        change(e) { },

        openBeizhu(item) {
            this.beizhuId = item.id;

            this.beizhuShow = true;
        },
        isUrl(url) {
            if (!url) {
                return false
            }
            const index = url.indexOf('http')
            if (index > -1) {
                return true
            }
            return false
        },
        copyText(text) {
            // 创建临时input
            const input = document.createElement('input');
            input.value = text;
            document.body.appendChild(input);
            input.select();
            document.execCommand('copy');
            document.body.removeChild(input);
            this.$message({
                message: "复制成功！",
                type: "success",
            });
        },
        openPay(item) {
            console.log(item);

            if (item.payUrl == null || item.payUrl == "") {
                this.$message({
                    message: "未获取到支付链接",
                    type: "warning",
                });
            } else {
                if (this.isUrl(item.payUrl)) {
                    window.open(item.payUrl);
                    paycallbackloop({
                        orderApplicantId: item.id,
                    }).then((res) => {
                    }).finally(() => {
                        // 调用定时器刷新申请人数据
                        this.clickApplicantStatusPay(this.applicationForm)
                    })
                } else {
                    this.copyText(item.payUrl);
                }
            }
        },
        addUserFn(e = []) {
            if (this.applicationLoading) {
                return;
            }
            let oldArr = [];
            // 修复bug只是新增一个申请人，前端传递了所有申请人数据，导致重复
            // this.orderDetail.orderApplicants.forEach(item => {
            //     oldArr.push({
            //         applicantName: item.applicantName,
            //         identityTypeId: item.identityType,
            //         id: item.id
            //     })
            // })

            let arr = [...e, ...oldArr];
            this.applicationLoading = true;
            addorderapplicants({
                orderId: this.id,
                DepartureTime: this.dateInfo.date,
                applicants: arr,
            })
                .then((res) => {
                    if (res.code == 1) {
                        this.$message({
                            message: "添加成功！",
                            type: "success",
                        });
                        this.orderdetailFn();
                        this.userId = 0;
                        sessionStorage.removeItem("km_userId");
                        setTimeout(() => {
                            this.queryorderapplicantsFn(true);
                        }, 1800);
                        this.newAddUserShow = false;
                    } else {
                        this.$message({
                            message: res.msg,
                            type: "warning",
                        });
                        this.applicationLoading = false;
                    }
                })
                .catch(() => {
                    this.applicationLoading = false;
                });
        },
        addUser() {
            this.newAddUserShow = true;
        },
        downPackage(item) {
            window.open(item.visaPage);
        },
        setColl(row) {
            let vm = this;
            vm.userId = row.id;
            sessionStorage.setItem("km_userId", row.id);
            this.applicantLoading = true;
            const requestId = ++this.currentRequestId;
            setTimeout(() => {
                this.applicantLoading = false;
            }, 600);

            vm.userList.forEach((item) => {
                if (row.id == item.id) {
                    if (requestId == this.currentRequestId) {
                        vm.applicationForm = item;
                        // 提交中状态轮询查询订单状态
                        vm.clickApplicantStatus(vm.applicationForm);
                    }
                }
            });
            this.reload();
        },
        rowClassFun(item) {
            // console.log('itemitem', item);
            if (item.row.status == this.submitIngStatus) {
                return "submitting_calss";
            } else {
                return "";
            }
        },
        copyOrder() {
        },
        editSf(e, elem) {
            let vm = this;
            let oldArr = [];

            vm.orderDetail.orderApplicants.forEach((item) => {
                if (item.id == elem.id) {
                    item.identityType = e;
                }
            });

            vm.orderDetail.orderApplicants.forEach((item) => {
                oldArr.push({
                    applicantName: item.applicantName,
                    identityTypeId: item.identityType,
                    id: item.id,
                });
            });
            let arr = [...oldArr];
            upadateorderapplicants({
                orderId: this.id,
                applicants: arr,
            }).then((res) => {
                if (res.code == 1) {
                    this.$message({
                        message: "修改成功！",
                        type: "success",
                    });
                    this.queryorderapplicantsFn();
                    this.isVisible = false;
                }
            });
        },
        // 提交中状态轮询查询订单状态
        clickApplicantStatus() {
            let vm = this;
            if (this.applicantstatusTimer) {
                clearInterval(this.applicantstatusTimer);
                this.applicantstatusTimer = null;
            }
            if (this.applicationForm.status == this.submitIngStatus) {
                vm.applicantstatusTimer = setInterval(() => {
                    vm.applicantstatusFun(vm.applicationForm);
                }, 1000);
            }
        },
        // 支付中状态轮询查询订单状态
        clickApplicantStatusPay() {
            let vm = this;
            if (this.applicantstatusTimerPay) {
                clearInterval(this.applicantstatusTimerPay);
                this.applicantstatusTimerPay = null;
            }
            if (this.applicationForm.status == this.submitIngStatusPay) {
                vm.applicantstatusTimerPay = setInterval(() => {
                    vm.applicantstatusFun(vm.applicationForm, 'pay');
                }, 1000);
            }
        },
        // 查询申请人状态
        applicantstatusFun(applicationForm, type = "") {
            applicantstatus({
                orderApplicantId: applicationForm.id,
            }).then((res) => {
                if (type == 'pay') {
                    if (res.code == 1 && res.data && res.data != this.submitIngStatusPay) {
                        // 状态更新刷新列表
                        // this.orderdetailFn();
                        this.queryorderapplicantsFn();
                        if (this.applicantstatusTimerPay) {
                            clearInterval(this.applicantstatusTimerPay);
                            this.applicantstatusTimerPay = null;
                        }
                    }
                } else {
                    if (res.code == 1 && res.data && res.data != this.submitIngStatus) {
                        // 状态更新刷新列表
                        // this.orderdetailFn();
                        this.queryorderapplicantsFn();

                        if (this.applicantstatusTimer) {
                            clearInterval(this.applicantstatusTimer);
                            this.applicantstatusTimer = null;
                        }
                    }
                }

            });
        }
    },
    destroyed() {
        console.log('destroyed')
        if (this.applicantstatusTimer) {
            clearInterval(this.applicantstatusTimer);
            this.applicantstatusTimer = null;
        }

        if (this.applicantstatusTimerPay) {
            clearInterval(this.applicantstatusTimerPay);
            this.applicantstatusTimerPay = null;
        }
    },
    beforeDestroy() {
        console.log('beforeDestroy')
        sessionStorage.removeItem("km_userId");
        if (this.applicantstatusTimer) {
            clearInterval(this.applicantstatusTimer);
            this.applicantstatusTimer = null;
        }

        if (this.applicantstatusTimerPay) {
            clearInterval(this.applicantstatusTimerPay);
            this.applicantstatusTimerPay = null;
        }
    },
};
</script>
<style lang="scss" scoped>
.order-detail-zdh {
    .yellow-cls {
        input {
            color: #eebb17;
        }
    }

    .green-cls {
        input {
            color: #1c9c1c;
        }
    }

    .red-cls {
        input {
            color: #e41313;
        }
    }

    .detail-status-dialog {
        .el-dialog {
            background-color: transparent;

            .el-dialog__header {
                display: none;
            }

            .el-dialog__body {
                background: linear-gradient(180deg, #e7ecfb 0%, #f6f8fe 24%, #ffffff 100%);
                border-radius: 12px;
                box-sizing: border-box;
                overflow: hidden;
            }

        }
    }
}

.order-detail-child {
    iframe {
        .countryContainer {
            background: #fff !important;
        }
    }

    .dialog-order-detail-wrap {
        background: none !important;
        border-radius: 12px;

        .el-dialog {
            background: none;
        }

        .el-dialog__header {
            display: none;
        }

        .el-dialog__body {
            width: 419px;

            // height: 285px;
            background: linear-gradient(180deg,
                    #e7ecfb 0%,
                    #f6f8fe 24%,
                    #ffffff 100%);
            border-radius: 12px;
            box-sizing: border-box;
            overflow: hidden;
        }
    }

    .select-input {
        input {
            width: 89px;
            height: 28px;
            line-height: 28px;
            padding: 0 5px;
            font-size: 12px;
            background: #f5f8fd;
        }
    }

    .dialog-wrap-dowm {}

    .page-order-table-box {
        .el-table__body-wrapper {
            font-size: 12px;
        }

        .el-table .submitting_calss {
            opacity: 1;

            .el-icon-loading {
                color: #409eff;
            }
        }
    }

    .el-select__caret {
        display: block;
        line-height: 28px !important;
    }

    .current-row {
        td {
            background-color: rgba(222, 239, 255, 0.726) !important;
        }
    }

    .form-item-btn {
        text-align: right;
    }

    .demo-ruleForm {
        display: flex;
        flex-wrap: wrap;
        justify-content: space-between;

        .demo-ruleForm-radio {
            text-align: left;
        }

        .el-form-item {
            display: flex;
            flex-wrap: wrap;
            margin-bottom: 6px;
            width: 323px;

            &.form-item-btn {
                width: 100%;
            }

            .el-date-editor {
                width: 100%;
            }

            &:nth-child(1) {
                margin-right: 130px;
            }

            .el-form-item__label {
                width: 50px !important;
                white-space: nowrap;
                height: 30px;
            }

            .el-form-item__content {
                margin-left: 0px !important;
            }
        }

        .el-form-item__content {
            text-align: right;

            .el-button {
                margin-top: 20px;
            }
        }
    }
}
</style>
<style lang="scss" scoped>
.filter_btn {
    cursor: pointer;
    font-size: 10px;
    color: #333;
}

.active {
    color: #0094e8;
}

.order-detail-child {
    height: 100%;
    background: #f7f8fa;
    // padding-bottom: 100px;
}

.packge-btn-add {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-wrap: nowrap;

    .pageck-btn {
        width: 145px;
        margin: 0 16px;
    }
}

.sf-list {
    display: flex;
    flex-direction: column;
    margin-top: -20px;

    .sf-label {
        margin-bottom: 15px;
        color: #999;
    }

    .sf-radio {
        margin-bottom: 15px;
    }

    .sf-btn {
        text-align: right;
    }
}

.page-order-detaul-bom {
    width: 1200px;
    display: flex;
    height: calc(100% - 60px);

    .page-order-detail-left {
        width: 398px;
        height: 100%;
        display: flex;
        flex-direction: column;
        // padding-bottom: 30px;

        .page-order-item-info {
            width: 100%;
            padding: 20px;
            box-sizing: border-box;
            margin-bottom: 20px;
            background: #fff;
            padding-bottom: 60px;
            position: relative;

            .page-order-up {
                text-align: center;
                color: #0094e8;
                position: absolute;
                left: 0px;
                bottom: 0px;
                width: 398px;
                text-align: center;
                border-top: 1px solid #eeeeee;
                // padding-top: 15px;
                // padding-bottom: 15px;
                height: 36px;
                line-height: 28px;
                z-index: 2;
                background: #fff;
                cursor: pointer;
            }

            .page-order-item-t {
                display: flex;
                align-items: center;

                .page-order-status-name {
                    padding: 4px 14px;
                    background: #ddf0dd;
                    color: #1c9c1c;
                    border-radius: 4px;
                    margin-left: 18px;
                    font-weight: bold;

                    &.sty-red {
                        background: #fbdbdb;
                        color: #e41313;
                    }

                    &.sty-yello {
                        background: #fdf5dc;
                        color: #eebb17;
                    }
                }

                span {
                    width: 120px;
                }

                .source-type {
                    display: inline-block;
                    width: 16px;
                    height: 16px;
                    text-align: center;
                    line-height: 16px;
                    background: #4791ea;
                    border-radius: 4px;
                    color: #fff;
                    font-size: 10px;
                    margin-right: 5px;
                }

                .marks-line {
                    display: -webkit-box;
                    /* 将对象作为弹性伸缩盒子模型显示 */
                    -webkit-box-orient: vertical;
                    /* 设置或检索伸缩盒对象的子元素的排列方式 */
                    -webkit-line-clamp: 3;
                    /* 限制在一个块元素显示的文本的行数 */
                    overflow: hidden;
                    /* 隐藏溢出的内容 */
                }

                .icon-a-xiugai1 {
                    color: #3888e9;
                    cursor: pointer;
                    font-size: 12px;
                }
            }
        }

        .page-order-item-table {
            width: 398px;
            background: #fff;
            //min-height: 550px;
            height: calc(100% - 255px);
            padding-bottom: 16px;

            .page-order-detail-btn {
                padding: 20px;
                padding-bottom: 0px;
            }

            .page-order-table-box {
                padding: 0 20px;
                height: 100%;
                min-height: 300px;
            }
        }
    }

    .page-order-detail-bottom {
        width: 784px;
        // height: 100%;
        // height: 1107px;
        // background: #FFF;
        margin-left: 20px;
        position: relative;

        .page-order-detail {
            width: 100%;
            height: 100%;
        }

        .page-table-box {
            position: fixed;
            top: -99999;
            left: -99999;
            opacity: 0;
        }

        .page-order-detail-bottom-title {
            width: 100%;
            height: 64px;
            background: #fff8ee;
            font-size: 14px;
            color: #ff9d3d;
            padding: 12px;
            box-sizing: border-box;
            margin-bottom: 30px;
        }

        .page-order-detail-bottom-content {
            position: relative;
            // height: 980px;

            // background: rgb(138, 115, 115);
            width: 100%;

            iframe {
                flex: 1;
                width: 784px;
                height: 628px;

                .countryContainer {
                    background: #fff !important;
                }
            }

            .no-iframe {
                position: absolute;
                top: 64px;
                width: 100%;
                height: 100%;
                display: flex;
                justify-content: center;
                align-items: center;
                color: #6666;
                font-size: 18px;
                border-radius: 12px;
                background-color: #f5f5f5;
            }
        }

        .page-rder-detail-bottom-btn {
            box-shadow: 0px -3px 12px 1px rgba(102, 102, 102, 0.1);
            flex: 1;
            height: 65px;
            line-height: 61px;
            text-align: right;
            display: flex;
            justify-content: space-between;
            padding: 0 10px;
            background: #fff;
            width: auto !important;
        }
    }

    // background: #FFF;
}

.table-pagination {
    text-align: center;
    margin-top: 16px;
}

.order-wrap {
    width: 1200px;
    height: 100%;
    margin: 0 auto;

    .order-content {
        width: 1200px;
        // height: 831px;
        background: #fff;
        box-shadow: 0px 0px 6px 1px rgba(0, 0, 0, 0.16);
    }

    .page-path {
        margin: 16px 0;
        font-size: 12px;
        // color: #CCCCCC;
        color: #a19f9f;

        span {
            cursor: pointer;
        }
    }

    .page-card-top {
        padding: 20px;
        box-sizing: border-box;
        display: flex;
        align-items: center;
        justify-content: space-between;
        height: 60px;
        border-bottom: 3px solid #f5f5f5;

        .page-card-top-left {
            display: flex;
            align-items: center;
        }

        .page-card-right {}

        .page-top-back {
            font-size: 16px;
            color: #3888e9;
            cursor: pointer;

            i {
                color: #3888e9;
                font-weight: bold;
            }
        }

        .page-top-name {
            margin-left: 32px;
            font-size: 18px;
            font-weight: bold;
        }

        .page-top-identity {
            margin-left: 20px;
            font-size: 16px;
            font-weight: bold;
            color: #666666;
        }

        .page-card-top-left {}
    }

    .lan {
        color: #3888e9;
        cursor: pointer;
    }

    .page-card-conetent {
        height: 668px;
        width: 100%;
        flex: 1;

        iframe {
            flex: 1;
            width: 1200px;
            height: 668px;
        }
    }

    .flex-app {
        display: flex;
        flex-direction: column;
    }

    .page-card-bom {
        height: 97px;
        border-top: 3px solid #f5f5f5;
        display: flex;
        align-items: center;
        justify-content: center;

        .page-card-bom-btn {
            margin: auto;
            width: 138px;
            height: 45px;
        }
    }

    .page-card {
        width: 1200px;
        background: #ffffff;
        box-shadow: 0px 0px 6px 1px rgba(0, 0, 0, 0.16);

        .page-require-box {
            width: 100%;

            .page-title {
                height: 42px;
                padding-left: 24px;
                font-size: 16px;
                color: #3888e9;
                display: flex;
                align-items: center;
                background: #f2f8ff;
            }

            .page-item {
                padding: 20px 24px;
                background: #fff;
                border-bottom: 5px solid #f7f8fa;

                .page-item-avatar {
                    .page-item-name {
                        display: block;
                        margin-bottom: 12px;
                    }

                    .page-item-flex {
                        display: flex;
                        //  align-items: center;

                        .page-item-no-passport {
                            display: flex;
                            align-items: center;
                            margin-left: 77px;
                            // margin-top: 38px;
                        }

                        .page-input {
                            width: 734px;
                            margin-left: 26px;

                            .page-item-title {
                                width: 100%;
                                height: 38px;
                                background: #f2f8ff;
                                color: #3888e9;
                                font-size: 16px;
                                display: flex;
                                align-items: center;
                                justify-content: center;
                            }

                            .page-item-waning {
                                color: #ff5967;

                                .el-icon-warning-outline {
                                    margin-right: 8px;
                                }
                            }

                            .page-item-wrap {
                                background: #f7f8fa;
                                min-height: 400px;
                                width: 100%;
                                padding: 12px 28px;
                                box-sizing: border-box;

                                .page-item-top {
                                    display: flex;
                                    justify-content: space-between;
                                    align-items: center;
                                    font-size: 14px;

                                    .page-edit {
                                        color: #5f9fed;
                                        cursor: pointer;
                                    }
                                }

                                .demo-list {
                                    display: flex;
                                    flex-wrap: wrap;
                                    margin-top: 16px;

                                    li {
                                        width: 330px;
                                        display: flex;
                                        margin-bottom: 24px;

                                        span {
                                            width: 110px;
                                            color: #666;
                                            font-size: 14px;
                                        }

                                        p {
                                            font-size: 16px;
                                            font-weight: bold;
                                        }
                                    }
                                }
                            }
                        }

                        .page-item-legend {
                            width: 222px;
                            height: 151px;
                            margin-left: 16px;
                        }

                        .page-item-desc {
                            max-width: 336px;
                            flex: flex;
                            flex-direction: column;
                            margin-left: 20px;

                            span {
                                font-size: 16px;
                            }

                            p {
                                font-size: 14px;
                                color: #999999;
                                margin-top: 8px;
                            }
                        }
                    }
                }
            }
        }
    }
}

// -------------------------- 变量定义（复用性更高） --------------------------
$primary-color: #409eff; // 主题蓝（Element-UI 主色）
$success-color: #67c23a; // 成功绿
$text-gray: #999; // 灰色文本
$border-gray: #e6e6e6; // 边框灰色
$font-size-sm: 12px; // 小字体
$font-size-base: 12px; // 基础字体
$spacing-sm: 5px; // 小间距
$spacing-base: 8px; // 基础间距
$spacing-md: 10px; // 中等间距
$spacing-lg: 15px; // 大间距
$spacing-xl: 20px; // 超大间距

// -------------------------- 混合器（复用样式逻辑） --------------------------
@mixin status-icon($bg-color) {
    width: 24px;
    height: 24px;
    border-radius: 50%;
    margin-right: $spacing-md;
    flex-shrink: 0;
    background: $bg-color;
    position: relative;
}

// -------------------------- 变量定义 --------------------------
$primary-color: #409eff; // 主题蓝（Element-UI 主色）
$success-color: #67c23a; // 成功绿
$text-gray: #B1B4BC; // 灰色文本
$border-gray: #e6e6e6; // 边框灰色
$font-size-sm: 12px; // 小字体
$font-size-base: 14px; // 基础字体
$spacing-sm: 5px; // 小间距
$spacing-base: 8px; // 基础间距
$spacing-md: 10px; // 中等间距
$spacing-lg: 15px; // 大间距
$spacing-xl: 20px; // 超大间距
$line-height-base: 1.5; // 基础行高
$scroll-container-height: 60vh; // 滚动容器高度

// -------------------------- 混合器 --------------------------
@mixin status-icon($bg-color) {
    width: 24px;
    height: 24px;
    border-radius: 50%;
    margin-right: $spacing-md;
    flex-shrink: 0;
    background: $bg-color;
    position: relative;
}

// -------------------------- 主体样式 --------------------------
.email-record-dialog {

    // 修复弹窗内滚动条与弹窗样式冲突
    ::v-deep .el-dialog__body {
        padding: 20px;
        max-height: 500px;
        overflow: hidden;
    }
}

#check-email-pop {
    ::v-deep .el-dialog__body {
        padding: 5px 20px;
    }
}

.email-record-container {
    width: 100%;
    height: 100%;

    // 顶部信息栏
    .header-info {
        padding-bottom: $spacing-lg;
        margin-bottom: $spacing-lg;
        font-size: $font-size-base;
        border-bottom: 1px solid $border-gray;

        .info-item {
            display: inline-block;
            margin-right: $spacing-xl;
        }
    }

    // 数量+刷新按钮行（布局优化）
    .count-refresh-row {
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin-bottom: $spacing-md;
        font-size: $font-size-base;
    }

    // 核心：可滚动的邮件列表容器
    .email-list-scroll {
        width: 100%;
        height: $scroll-container-height; // 固定容器高度
        overflow-y: auto; // 垂直方向滚动
        overflow-x: hidden; // 水平方向隐藏
        margin-top: $spacing-md;

        // 自定义滚动条样式（可选，提升美观度）
        &::-webkit-scrollbar {
            width: 6px;
        }

        &::-webkit-scrollbar-track {
            background: #f1f1f1;
            border-radius: 3px;
        }

        &::-webkit-scrollbar-thumb {
            background: #dcdcdc;
            border-radius: 3px;

            &:hover {
                background: #c0c0c0;
            }
        }
    }

    .email-list {
        width: 100%;

        .email-item {
            display: flex;
            align-items: flex-start;
            padding: $spacing-lg 0;
            border-bottom: 1px solid $border-gray;

            .status-icon {
                &.success-icon {
                    @include status-icon($success-color);

                    &::after {
                        content: "";
                        position: absolute;
                        top: 6px;
                        left: 8px;
                        width: 6px;
                        height: 12px;
                        border: solid white;
                        border-width: 0 2px 2px 0;
                        transform: rotate(45deg);
                    }
                }

                &.info-icon {
                    @include status-icon($primary-color);

                    &::after {
                        content: "i";
                        position: absolute;
                        top: 2px;
                        left: 8px;
                        color: white;
                        font-size: 16px;
                        font-weight: bold;
                    }
                }
            }

            .email-content {
                flex: 1;
                width: calc(100% - 34px); // 减去图标宽度+间距

                .status-label {
                    font-size: $font-size-base;
                    margin-bottom: $spacing-sm;
                    margin-right: 15px;
                    padding: 2px 4px;
                    border-radius: 4px;
                    background-color: #EAF7EC;
                    color: #60C570;
                }

                .email-time {
                    color: $text-gray;
                    font-size: $font-size-sm;
                    margin-bottom: $spacing-base;
                }

                // 两行截断样式
                .email-desc {
                    font-size: $font-size-base;
                    line-height: $line-height-base;
                    margin-bottom: $spacing-base;
                    display: -webkit-box;
                    -webkit-line-clamp: 2;
                    -webkit-box-orient: vertical;
                    overflow: hidden;
                    text-overflow: ellipsis;

                    // 富文本样式支持
                    p {
                        margin: 8px 0;
                    }

                    br {
                        line-height: 1.5;
                    }

                    a {
                        color: $primary-color;
                        text-decoration: underline;
                    }

                    strong {
                        font-weight: bold;
                    }

                    em {
                        font-style: italic;
                    }

                    // 展开状态取消截断
                    &.expanded {
                        -webkit-line-clamp: unset;
                        height: auto;
                        overflow: visible;
                    }
                }

                .view-detail {
                    color: $primary-color;
                    font-size: $font-size-base;
                    text-decoration: none;
                    cursor: pointer;

                    &:hover {
                        text-decoration: underline;
                    }
                }
            }
        }
    }
}

#check-email-pop .dialog-footer {
    text-align: right;
}


::v-deep iframe {
    flex: 1;
    width: 784px;
    height: 628px;
    font-size: 16px;

    body {
        font-size: 16px;
    }

    .countryContainer {
        background: #fff !important;
    }
}

/* 商户历史记录样式 */
.merchant-history {
    display: flex;
    flex-wrap: wrap;
    gap: 15px;
    item-align: center;
    margin-top: 8px;


    .history-item {
        padding: 1px 6px;
        background-color: #f5f7fa;
        border: 1px solid #e4e7ed;
        line-height: 25px;
        height: 25px;
        border-radius: 2px;
        font-size: 10px;
        color: #606266;
        cursor: pointer;
        transition: all 0.2s;

        &:hover {
            background-color: #ecf5ff;
            border-color: #409eff;
            color: #409eff;
        }
    }
}
</style>
